import React, { useEffect, useState } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { getTestById } from '../services/testService';
import { Modal } from 'antd';
import axios from 'axios';
import mongoose from 'mongoose';

const TakeTestPage = () => {
  const { testId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [studentId, setStudentId] = useState(null);

useEffect(() => {
  const studentData = JSON.parse(localStorage.getItem('student'));
  setStudentId(studentData?.id);
  console.log("Student ID from localStorage: ", studentData?.id);
}, []);



  const [questions, setQuestions] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [answers, setAnswers] = useState({});
  const [loading, setLoading] = useState(true);
  const [timeLeft, setTimeLeft] = useState(3600); // 1 hour in seconds
  const [isModalVisible, setIsModalVisible] = useState(false);

  useEffect(() => {
    const fetchTest = async () => {
      try {
        const test = await getTestById(testId);
        setQuestions(test.questions);
      } catch (err) {
        console.error('Failed to load test:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchTest();
  }, [testId]);

  // Countdown timer logic
  useEffect(() => {
    if (timeLeft > 0) {
      const timer = setInterval(() => {
        setTimeLeft((prev) => prev - 1);
      }, 1000);

      return () => clearInterval(timer);
    } else {
      setIsModalVisible(true); // Show modal when time is up
    }
  }, [timeLeft]);

  const handleAnswerChange = (e) => {
    setAnswers({
      ...answers,
      [currentIndex]: e.target.value,
    });
  };

  const goToQuestion = (index) => {
    setCurrentIndex(index);
  };

  // 🚀 **Backend API Call to Submit Test**
const handleSubmit = async () => {
  try {
    const isValidObjectId = mongoose.Types.ObjectId.isValid(studentId);

    if (!isValidObjectId) {
      console.error("Invalid student ID format!");
      return;
    }

    let score = 0;
    const sectionStats = {};

    questions.forEach((question, index) => {
      const selectedAnswer = answers[index];
      const isCorrect = selectedAnswer === question.correctAnswer;

      const section = question.section || 'General';

      if (!sectionStats[section]) {
        sectionStats[section] = { correct: 0, incorrect: 0, skipped: 0, total: 0 };
      }

      sectionStats[section].total++;

      if (selectedAnswer === undefined) {
        sectionStats[section].skipped++;
      } else if (isCorrect) {
        sectionStats[section].correct++;
        score++;
      } else {
        sectionStats[section].incorrect++;
      }
    });

    const payload = {
      student: studentId,
      testNumber: testId,
      questions: questions.map(q => q._id),
      status: 'completed',
      completedAt: new Date(),
      results: answers,
      score,
      sectionStats
    };

    console.log("Payload being sent: ", payload);

    const response = await axios.post('https://devexam.doode.in/api/test-attempt/submit', payload);

    if (response.status === 200) {
      console.log("Test submitted successfully!");
      navigate('/test-result', { state: { questions, answers, score, sectionStats } });
    }
  } catch (error) {
    console.error('Error submitting test:', error);
  }
};


  const handleAutoSubmit = () => {
    setIsModalVisible(false);
    handleSubmit();
  };

  if (loading) return <div>Loading test...</div>;

  // Format time as MM:SS
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
  };

  return (
    <div style={{ display: 'flex', gap: '1rem', padding: '1rem' }}>
      <div style={{ flex: 2, padding: '1rem', borderRight: '1px solid #ccc' }}>
        {questions.length > 0 && (
          <>
            <h4 style={{ fontWeight: '600', fontSize: '18px', marginBottom: '1rem' }}>
              Question {currentIndex + 1}:
            </h4>
            <p style={{ marginBottom: '1rem' }}>{questions[currentIndex].questionText}</p>

            {Array.isArray(questions[currentIndex].options) &&
              questions[currentIndex].options.length > 0 && (
                <div>
                  {questions[currentIndex].options.map((option, idx) => (
                    <div key={idx} style={{ marginBottom: '0.5rem' }}>
                      <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                        <input
                          type="radio"
                          name={`question-${currentIndex}`}
                          value={option}
                          checked={answers[currentIndex] === option}
                          onChange={handleAnswerChange}
                        />
                        <span>{option}</span>
                      </label>
                    </div>
                  ))}
                </div>
              )}

            <div style={{ marginTop: '1rem' }}>
              <button
                onClick={() => setCurrentIndex((prev) => Math.max(prev - 1, 0))}
                disabled={currentIndex === 0}
                style={{ marginRight: '1rem' }}
              >
                Previous
              </button>
              <button
                onClick={() => setCurrentIndex((prev) => Math.min(prev + 1, questions.length - 1))}
                disabled={currentIndex === questions.length - 1}
              >
                Next
              </button>
              <button
                onClick={handleSubmit}
                style={{ marginLeft: '1rem' }}
              >
                Submit Test
              </button>
            </div>
          </>
        )}
      </div>

      <div style={{ flex: 1, padding: '1rem' }}>
        <div style={{ textAlign: 'right', fontSize: '18px', fontWeight: '600', color: '#ff4d4f', marginBottom: '1rem' }}>
          Time Left: {formatTime(timeLeft)}
        </div>

        <h3 style={{ fontWeight: '600', marginBottom: '1rem', textAlign: 'center' }}>Question Navigator</h3>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: '0.5rem' }}>
          {questions.map((_, i) => (
            <button
              key={i}
              onClick={() => goToQuestion(i)}
              style={{
                width: '40px',
                height: '40px',
                borderRadius: '50%',
                border: '1px solid #ccc',
                backgroundColor: i === currentIndex ? '#1890ff' : answers[i] ? '#52c41a' : '#f0f0f0',
                color: i === currentIndex || answers[i] ? '#fff' : '#000',
                cursor: 'pointer'
              }}
            >
              {i + 1}
            </button>
          ))}
        </div>
      </div>

      <Modal
        title="Time Over"
        visible={isModalVisible}
        onOk={handleAutoSubmit}
        okText="Submit Test"
        cancelButtonProps={{ style: { display: 'none' } }}
      >
        <p>Time is up! Your test will now be submitted automatically.</p>
      </Modal>
    </div>
  );
};

export default TakeTestPage;
